import axios from 'axios'
import { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import { constants } from '../../Constants'
import { PageLoader } from '../SpinnerLoading/SpinnerLoading'

const MoneyChart = ({ selectedYear }) => {
  const [chartData, setChartData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchChartData = async () => {
      setLoading(true)
      try {
        const response = await axios.get(
          `${constants.urlLocal}getAllMoneyByYear/${selectedYear}`
        )
        setChartData(response.data.monthlyTotals || [])
      } catch (error) {
        console.error('Error al obtener los datos del gráfico', error)
      }
      setLoading(false)
    }
    fetchChartData()
  }, [selectedYear])

  const months = [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ]

  const options = {
    chart: { type: 'bar', toolbar: { show: false } },
    xaxis: { categories: months },
    colors: ['#2440ab'],
    plotOptions: { bar: { borderRadius: 4 } },
  }

  const series = [{ name: 'Ingresos (€)', data: chartData }]

  if (loading)
    return (
      <div className="flex-center" style={{ height: '200px' }}>
        <PageLoader />
      </div>
    )

  return (
    <div className="card-box">
      <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.5rem' }}>
        Ingresos Mensuales
      </h3>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={300}
      />
    </div>
  )
}

export { MoneyChart }
